import {
  MoreVertical,
  Copy,
  Trash2,
  Truck,
  PanelRight,
  Link,
  TrendingUp,
  Image as ImageIcon,
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface ItemActionsMenuProps {
  itemId: string
  onViewSecondaryAttributes: (itemId: string) => void
  onPlanWaves: (itemId: string) => void
  onCopy: (itemId: string) => void
  onDelete: (itemId: string) => void
  triggerAutoSave?: () => void
  isReadOnly?: boolean
  skuLevel?: string | null
  onAssignParentSku?: (itemId: string) => void
  onManagePIAB?: (itemId: string) => void
  onCreateForecast?: (itemId: string) => void
  onManageImages?: (itemId: string) => void
}

export function ItemActionsMenu({
  itemId,
  onViewSecondaryAttributes,
  onPlanWaves,
  onCopy,
  onDelete,
  triggerAutoSave,
  isReadOnly,
  skuLevel,
  onAssignParentSku,
  onManagePIAB,
  onCreateForecast,
  onManageImages,
}: ItemActionsMenuProps) {
  const handleOpenChange = (open: boolean) => {
    if (open && triggerAutoSave) {
      triggerAutoSave()
    }
  }

  return (
    <DropdownMenu onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" title="More">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => onViewSecondaryAttributes(itemId)}
          className="cursor-pointer"
        >
          <PanelRight className="mr-2 h-4 w-4" />
          <span>View Secondary Attributes</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onPlanWaves(itemId)}
          className="cursor-pointer"
          disabled={isReadOnly}
        >
          <Truck className="mr-2 h-4 w-4" />
          <span>Plan Waves</span>
        </DropdownMenuItem>
        {onManageImages && (
          <DropdownMenuItem
            onClick={() => onManageImages(itemId)}
            className="cursor-pointer"
            disabled={isReadOnly}
          >
            <ImageIcon className="mr-2 h-4 w-4" />
            <span>Manage Images</span>
          </DropdownMenuItem>
        )}
        {skuLevel === 'Child' && onAssignParentSku && (
          <DropdownMenuItem
            onClick={() => onAssignParentSku(itemId)}
            className="cursor-pointer"
            disabled={isReadOnly}
          >
            <Link className="mr-2 h-4 w-4" />
            <span>Assign Parent SKU</span>
          </DropdownMenuItem>
        )}
        {skuLevel === 'Parent' && onManagePIAB && (
          <DropdownMenuItem
            onClick={() => onManagePIAB(itemId)}
            className="cursor-pointer"
            disabled={isReadOnly}
          >
            <Link className="mr-2 h-4 w-4" />
            <span>Manage PIAB</span>
          </DropdownMenuItem>
        )}
        {onCreateForecast && (
          <DropdownMenuItem
            onClick={() => onCreateForecast(itemId)}
            className="cursor-pointer"
            disabled={isReadOnly}
          >
            <TrendingUp className="mr-2 h-4 w-4" />
            <span>Create Forecast Model</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={() => onCopy(itemId)}
          className="cursor-pointer"
          disabled={isReadOnly}
        >
          <Copy className="mr-2 h-4 w-4" />
          <span>Copy line</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onDelete(itemId)}
          className="cursor-pointer text-destructive focus:text-destructive"
          disabled={isReadOnly}
        >
          <Trash2 className="mr-2 h-4 w-4" />
          <span>Delete line</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
